module.exports = __webpack_public_path__ + "static/media/imagePagePlaceholderStandarPage.9393ddfb.svg";